<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-button class="item" icon="icon icon-jiarucopy" @click="on_create()" type="primary" />
                <a-divider type="vertical" class="item" />

                <a-select
                    v-model="group_id"
                    class="item"
                    v-if="data_group.length"
                    style="width:120px"
                    @change="(e) => on_field_change(e, 'group_id')"
                >
                    <a-select-option value="">全部部门</a-select-option>
                    <a-select-option v-for="item in data_group" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>

                <a-select
                    v-model="role_id"
                    class="item"
                    v-if="data_role.length"
                    style="width:120px"
                    @change="(e) => on_field_change(e, 'role_id')"
                >
                    <a-select-option value="">全部角色</a-select-option>
                    <a-select-option v-for="item in data_role" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
            </div>

            <div class="right-items">
                <a-input-search placeholder="模糊搜索" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                size="middle"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                :scroll="{ x: true }"
            >
                <!-- 创建时间 -->
                <template slot="created_render" slot-scope="text">{{ text ? moment(text * 1000).format("YYYY-MM-DD") : "" }}</template>

                <!-- 数量 -->
                <template slot="resource_count" slot-scope="text, record">
                    <a v-if="text" :href="`/resource/whole?user_id=${record.id}`" target="_blank">{{ text }}</a>
                </template>

                <!-- 数量 -->
                <template slot="member_count" slot-scope="text, record">
                    <a v-if="text" :href="`/member/whole?user_id=${record.id}`" target="_blank">{{ text }}</a>
                </template>

                <!-- 登录时间 -->
                <template slot="login_render" slot-scope="text">
                    <span v-if="text" v-html="$options.filters['friendly'](moment(text * 1000).format('YYYY-MM-DD HH:mm'))"></span>
                </template>

                <!-- 状态信息 -->
                <template slot="status" slot-scope="text, record">
                    <a-popconfirm v-if="text" title="是否禁用当前用户？" ok-text="是" cancel-text="否" @confirm="on_status(record, 0)">
                        <a-tag color="green" class="b-tag">启用</a-tag>
                    </a-popconfirm>
                    <a-popconfirm v-else title="是否启用当前用户？" ok-text="是" cancel-text="否" @confirm="on_status(record, 1)">
                        <a-tag color="red" class="b-tag">禁用</a-tag>
                    </a-popconfirm>
                </template>
                <!-- 员工信息 -->
                <template slot="user_render" slot-scope="text, record">
                    <div class="customer">
                        {{ record.name }}
                        <a-icon style="margin-left: 4px;color:#FF5722" type="icon icon-kefu" v-if="record.service"></a-icon>
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="operation" slot-scope="text, record">
                    <a-dropdown-button @click="on_edit(record)" size="small">
                        修改
                        <a-menu slot="overlay">
                            <a-menu-item key="disabled" @click="on_status(record, 0)" v-if="record.status"
                                ><a-icon type="stop" />禁用账户</a-menu-item
                            >
                            <a-menu-item key="enabled" @click="on_status(record, 1)" v-else
                                ><a-icon type="check-circle" />启用账户</a-menu-item
                            >

                            <a-menu-item key="transfer" @click="on_transfer(record)"><a-icon type="swap" />转移他的数据</a-menu-item>

                            <a-menu-item key="service" @click="on_service(record)"><a-icon type="user" />设置客服</a-menu-item>

                            <a-menu-divider />

                            <a-menu-item key="delete" @click="on_delete(record)" :disalbed="permissible.indexOf('member.delete') == -1"
                                ><a-icon type="delete" />删除</a-menu-item
                            >
                        </a-menu>
                    </a-dropdown-button>
                </template>
            </a-table>
        </div>

        <modal_create
            :visible="visible_create"
            @load="load"
            @close="visible_create = false"
            :record="selected_record"
            :mode="mode_create"
        />

        <modal_transfer
            :visible="visible_transfer"
            @load="load"
            @close="visible_transfer = false"
            :record="selected_record"
            :callback="load"
        />

        <modal_service
            :visible="visible_service"
            @close="visible_service = false"
            :record="{ user_id: selected_record ? selected_record.id : null }"
            :callback="load"
            :mode="mode_service"
        />
    </div>
</template>
<script>
    import modal_create from "./modal_create.vue";
    import modal_transfer from "./modal_transfer.vue";
    import modal_service from "../service/modal_create";
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";

    export default {
        components: { modal_create, modal_transfer, modal_service },
        mixins: [common_pagination],
        data() {
            return {
                path: "/setting/authority/user",
                visible_create: false,
                mode_create: "create",
                mode_service: "create",
                visible_service: false,
                selected_record: null,
                wd: null,
                visible_transfer: false,
                data_group: [],
                data_role: [],
                group_id: "",
                role_id: "",
                columns: [
                    {
                        dataIndex: "status",
                        title: "状态",
                        width: 60,
                        align: "center",
                        scopedSlots: {
                            customRender: "status",
                        },
                    },
                    {
                        dataIndex: "id",
                        title: "编号",
                        width: 70,
                    },
                    {
                        dataIndex: "name",
                        title: "姓名",
                        width: 100,
                        scopedSlots: {
                            customRender: "user_render",
                        },
                    },
                    {
                        dataIndex: "mobile",
                        width: 120,
                        title: "手机号码",
                    },
                    {
                        dataIndex: "group.name",
                        title: "所在部门",
                        width: 100,
                    },
                    {
                        dataIndex: "role.name",
                        title: "角色",
                        width: 100,
                    },
                    {
                        dataIndex: "groups",
                        title: "允许访问的部门",
                        width: 180,
                        ellipsis: true,
                        class: "small",
                        customRender: (e) => (e.length ? e.map((v) => v.name).join(",") : "-"),
                    },
                    {
                        dataIndex: "member_count",
                        title: "客户数量",
                        width: 70,
                        scopedSlots: {
                            customRender: "member_count",
                        },
                    },
                    {
                        dataIndex: "member_limit",
                        title: "客户限制",
                        width: 70,
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        class: "small",
                    },
                    // {
                    //     dataIndex: "expired_at_date_time",
                    //     title: "账号有限期"
                    // },
                    {
                        dataIndex: "last_login.created_at",
                        width: 120,
                        title: "最后登录时间",
                        scopedSlots: {
                            customRender: "login_render",
                        },
                    },
                    {
                        dataIndex: "created_at",
                        title: "创建时间",
                        width: 100,
                        scopedSlots: {
                            customRender: "created_render",
                        },
                    },
                    {
                        dataIndex: "operation",
                        title: "操作",
                        align: "center",
                        width: 100,
                        fixed: "right",
                        scopedSlots: {
                            customRender: "operation",
                        },
                    },
                ],
                data_source: [],
                loading: false,
            };
        },
        created() {
            this.parse_query();

            this.load();

            this.load_group();
            this.load_role();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            moment,
            parse_query() {
                let query = this.$route.query;
                if (Object.prototype.hasOwnProperty.call(query, "group_id")) {
                    this.group_id = Number(query["group_id"]);
                } else {
                    this.group_id = "";
                }
                if (Object.prototype.hasOwnProperty.call(query, "role_id")) {
                    this.role_id = Number(query["role_id"]);
                } else {
                    this.role_id = "";
                }
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/auth/user?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_group() {
                this.$http
                    .get("/auth/group")
                    .then((res) => {
                        if (res.success) {
                            this.data_group = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            load_role() {
                this.$http
                    .get("/auth/role")
                    .then((res) => {
                        if (res.success) {
                            this.data_role = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_edit(row) {
                this.selected_record = row;
                this.mode_create = "edit";
                this.visible_create = true;
            },
            on_create() {
                this.selected_record = {};
                this.visible_create = true;
                this.mode_create = "create";
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "警告",
                    content: `是否删除【${record.name}】`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/auth/user/" + record.id)
                                .then((res) => {
                                    if (res.success) {
                                        this.load();
                                        this.$message.success(res.message);
                                    } else {
                                        this.$error(res.message);
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_status(record, status) {
                this.$http
                    .post("/auth/user/status", {
                        value: status,
                        user_id: record.id,
                    })
                    .then((res) => {
                        if (!res.success) {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: res.message,
                            });
                        } else {
                            this.load();
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_transfer(record) {
                this.selected_record = record;
                this.visible_transfer = true;
            },
            on_service(record) {
                this.selected_record = record;
                this.mode_service = record.service ? "edit" : "create";
                this.visible_service = true;
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 57px;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }

    .customer {
        display: flex;
        align-items: center;
        .avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            margin-right: 8px;
        }
        .info {
            .name {
                font-size: 14px;
                font-weight: bold;
            }
            .id {
                font-size: 12px;
            }
        }
    }
</style>
